import React from 'react';
import { Switch, Route } from 'react-router-dom';
import About from './pages/About';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Skills from './pages/Skills';
import ProjectDetails from './pages/ProjectDetails';

const Body = () => {
    return (
        <Switch>
            <main className='bg-gray-300 lg:col-span-3 h:screen overflow-y-scroll'>
                <Route exact path='/'>
                    <Home />
                </Route>
                <Route path='/about'>
                    <About />
                </Route>
                <Route path='/skills'>
                    <Skills />
                </Route>
                <Route path='/projects'>
                    <Projects />
                </Route>
                <Route path='/contact'>
                    <Contact />
                </Route>
                <Route path='/project/:id'>
                    <ProjectDetails />
                </Route>
            </main>
        </Switch>
    )
}

export default Body;
